import { sample } from 'effector';
import {
  applyChatPublicHexagonsEv,
  revertChatPublicFiltersEv,
  saveChatPublicHexagonsEv,
} from './events.js';
import { $chatPublicHexagons, $isChatPublicFilters } from './stores.js';

$isChatPublicFilters
  .on(applyChatPublicHexagonsEv, () => true)
  .reset(revertChatPublicFiltersEv);

sample({
  source: $chatPublicHexagons,
  clock: saveChatPublicHexagonsEv,
  fn: (source, clock) => {
    return {
      ...source,
      [clock.message_index]: clock.map_data,
    };
  },
  target: $chatPublicHexagons,
});
